import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Button } from './ui/button';
import { NAVY } from '../lib/theme';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { User, LogOut, Menu } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export function Topbar({ onMenuClick, title = 'Dashboard' }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <header
      className="h-12 border-b flex items-center justify-between px-4 flex-shrink-0"
      style={{ background: NAVY.topbar, borderColor: NAVY.topbarBorder }}
    >
      <div className="flex items-center gap-3">
        <Button
          variant="ghost"
          size="icon"
          onClick={onMenuClick}
          className="lg:hidden h-8 w-8 hover:bg-white/5"
          style={{ color: NAVY.textActive }}
        >
          <Menu className="h-4 w-4" />
        </Button>
        <h1 className="text-sm font-semibold" style={{ color: NAVY.textActive }}>
          {title}
        </h1>
      </div>

      <div className="flex items-center gap-4">
        {/* User Dropdown */}
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              variant="ghost"
              size="sm"
              className="gap-2 hover:bg-white/5"
              style={{ color: NAVY.textActive }}
            >
              <div className="h-6 w-6 rounded-full bg-primary/20 flex items-center justify-center">
                <User className="h-3.5 w-3.5" style={{ color: NAVY.textActive }} />
              </div>
              <span className="hidden sm:inline-block text-xs">{user?.username}</span>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            align="end"
            className="w-56 border"
            style={{ background: NAVY.dropdownBg, borderColor: NAVY.dropdownBorder, color: NAVY.dropdownText }}
          >
            <DropdownMenuLabel>
              <div className="flex flex-col">
                <span className="text-sm font-medium" style={{ color: NAVY.textActive }}>{user?.username}</span>
                <span className="text-xs" style={{ color: NAVY.textMuted }}>Administrator</span>
              </div>
            </DropdownMenuLabel>
            <DropdownMenuSeparator style={{ background: NAVY.dropdownBorder }} />
            <DropdownMenuItem onClick={handleLogout} className="text-red-400 focus:text-red-400 focus:bg-white/5 cursor-pointer">
              <LogOut className="mr-2 h-4 w-4" />
              <span>Keluar</span>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  );
}